<template>
<!--联动选择地区-->
    <div>
        <el-select size="small" style="width: 80px"
                    v-model="selectProv"
                    placeholder="省份"
                    v-on:change="getProv($event)">
            <el-option
                    v-for="(item,index ) in provs"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
            </el-option>
        </el-select>
        <el-select size="small" style="width: 80px"
                    v-if="selectProv!=''"
                    v-model="selectCity"
                    placeholder="城市"
                    v-on:change="getCity($event)">
            <el-option
                    v-for="(item,index) in citys"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
            </el-option>
        </el-select>

        <el-button :disabled="!this.selectCity||!this.selectProv" type="primary" @click="handleSubmit" size="small" style="height: 32px;">确定</el-button>

    </div>    

</template>
<script>
     export default {
        data() {
            return {
                provs:[{label:"北京",value:"北京"},
            {label:"天津",value:"天津"},
            {label:"河北",value:"河北"},
            {label:"山西",value:"山西"},
            {label:"内蒙古",value:"内蒙古"},
            {label:"辽宁",value:"辽宁"},
            {label:"吉林",value:"吉林"},
            {label:"黑龙江",value:"黑龙江"},
            {label:"上海",value:"上海"},
            {label:"江苏",value:"江苏"},
            {label:"浙江",value:"浙江"},
            {label:"安徽",value:"安徽"},
            {label:"福建",value:"福建"},
            {label:"江西",value:"江西"},
            {label:"山东",value:"山东"},
            {label:"河南",value:"河南"},
            {label:"湖北",value:"湖北"},
            {label:"湖南",value:"湖南"},
            {label:"广东",value:"广东"},
            //{label:"广西壮族",value:"广西壮族"},
            {label:"海南",value:"海南"},
            {label:"重庆",value:"重庆"},
            {label:"四川",value:"四川"},
            {label:"贵州",value:"贵州"},
            {label:"云南",value:"云南"},
            {label:"西藏",value:"西藏"},
            {label:"陕西",value:"陕西"},
            {label:"甘肃",value:"甘肃"},
            {label:"青海",value:"青海"},
            // {label:"宁夏回族",value:"宁夏回族"},
            // {label:"新疆维吾尔",value:"新疆维吾尔"},
            // {label:"台湾",value:"台湾"},
            // {label:"香港特别行政区",value:"香港特别行政区"},
            // {label:"澳门特别行政区",value:"澳门特别行政区"}
            
            ] ,
                citys: [],
                selectProv: '',
                selectCity: ''
            }
        },
        methods: {
            /*二级联动选择地区*/
            getProv: function (prov) {
                let tempCity=[];              
                this.citys=[];
                this.selectCity='';               
                let allCity=[{
                    prov: "北京",
                    label: "北京"
                }, {
                    prov: "天津",
                    label: "天津"
                }, {
                    prov: "河北",
                    label: "河北"
                }, {
                    prov: "河北",
                    label: "石家庄"
                }, {
                    prov: "河北",
                    label: "唐山"
                }, {
                    prov: "河北",
                    label: "秦皇岛"
                }, {
                    prov: "河北",
                    label: "邯郸"
                }, {
                    prov: "河北",
                    label: "邢台"
                }, {
                    prov: "河北",
                    label: "保定"
                }, {
                    prov: "河北",
                    label: "张家口"
                }, {
                    prov: "河北",
                    label: "承德"
                }, {
                    prov: "河北",
                    label: "沧州"
                }, {
                    prov: "河北",
                    label: "廊坊"
                }, {
                    prov: "河北",
                    label: "衡水"
                }, {
                    prov: "山西",
                    label: "山西"
                },  {
                    prov: "山西",
                    label: "太原"
                }, {
                    prov: "山西",
                    label: "大同"
                }, {
                    prov: "山西",
                    label: "阳泉"
                }, {
                    prov: "山西",
                    label: "长治"
                }, {
                    prov: "山西",
                    label: "晋城"
                }, {
                    prov: "山西",
                    label: "朔州"
                }, {
                    prov: "山西",
                    label: "晋中"
                }, {
                    prov: "山西",
                    label: "运城"
                }, {
                    prov: "山西",
                    label: "忻州"
                }, {
                    prov: "山西",
                    label: "临汾"
                }, {
                    prov: "山西",
                    label: "吕梁"
                }, {
                    prov: "内蒙古",
                    label: "呼和浩特"
                }, {
                    prov: "内蒙古",
                    label: "内蒙古"
                }, {
                    prov: "内蒙古",
                    label: "包头"
                }, {
                    prov: "内蒙古",
                    label: "乌海"
                }, {
                    prov: "内蒙古",
                    label: "赤峰"
                }, {
                    prov: "内蒙古",
                    label: "通辽"
                }, {
                    prov: "内蒙古",
                    label: "鄂尔多斯"
                }, {
                    prov: "内蒙古",
                    label: "呼伦贝尔"
                }, {
                    prov: "内蒙古",
                    label: "巴彦淖尔"
                }, {
                    prov: "内蒙古",
                    label: "乌兰察布"
                }, {
                    prov: "内蒙古",
                    label: "兴安盟"
                }, {
                    prov: "内蒙古",
                    label: "锡林郭勒盟"
                }, {
                    prov: "内蒙古",
                    label: "阿拉善盟"
                }, {
                    prov: "辽宁",
                    label: "辽宁"
                },{
                    prov: "辽宁",
                    label: "沈阳"
                }, {
                    prov: "辽宁",
                    label: "大连"
                }, {
                    prov: "辽宁",
                    label: "鞍山"
                }, {
                    prov: "辽宁",
                    label: "抚顺"
                }, {
                    prov: "辽宁",
                    label: "本溪"
                }, {
                    prov: "辽宁",
                    label: "丹东"
                }, {
                    prov: "辽宁",
                    label: "锦州"
                }, {
                    prov: "辽宁",
                    label: "营口"
                }, {
                    prov: "辽宁",
                    label: "阜新"
                }, {
                    prov: "辽宁",
                    label: "辽阳"
                }, {
                    prov: "辽宁",
                    label: "盘锦"
                }, {
                    prov: "辽宁",
                    label: "铁岭"
                }, {
                    prov: "辽宁",
                    label: "朝阳"
                }, {
                    prov: "辽宁",
                    label: "葫芦岛"
                }, {
                    prov: "吉林",
                    label: "长春"
                }, {
                    prov: "吉林",
                    label: "吉林"
                }, {
                    prov: "吉林",
                    label: "四平"
                }, {
                    prov: "吉林",
                    label: "辽源"
                }, {
                    prov: "吉林",
                    label: "通化"
                }, {
                    prov: "吉林",
                    label: "白山"
                }, {
                    prov: "吉林",
                    label: "松原"
                }, {
                    prov: "吉林",
                    label: "白城"
                },
//  {
//                     prov: "吉林",
//                     label: "延边朝鲜族自治州"
//                 }, 
                {
                    prov: "黑龙江",
                    label: "黑龙江"
                }, {
                    prov: "黑龙江",
                    label: "哈尔滨"
                }, {
                    prov: "黑龙江",
                    label: "齐齐哈尔"
                }, {
                    prov: "黑龙江",
                    label: "鸡西"
                }, {
                    prov: "黑龙江",
                    label: "鹤岗"
                }, {
                    prov: "黑龙江",
                    label: "双鸭山"
                }, {
                    prov: "黑龙江",
                    label: "大庆"
                }, {
                    prov: "黑龙江",
                    label: "伊春"
                }, {
                    prov: "黑龙江",
                    label: "佳木斯"
                }, {
                    prov: "黑龙江",
                    label: "七台河"
                }, {
                    prov: "黑龙江",
                    label: "牡丹江"
                }, {
                    prov: "黑龙江",
                    label: "黑河"
                }, {
                    prov: "黑龙江",
                    label: "绥化"
                }, {
                    prov: "黑龙江",
                    label: "大兴安岭地区"
                }, {
                    prov: "上海",
                    label: "上海"
                }, {
                    prov: "江苏",
                    label: "南京"
                }, {
                    prov: "江苏",
                    label: "江苏"
                }, {
                    prov: "江苏",
                    label: "无锡"
                }, {
                    prov: "江苏",
                    label: "徐州"
                }, {
                    prov: "江苏",
                    label: "常州"
                }, {
                    prov: "江苏",
                    label: "苏州"
                }, {
                    prov: "江苏",
                    label: "南通"
                }, {
                    prov: "江苏",
                    label: "连云港"
                }, {
                    prov: "江苏",
                    label: "淮安"
                }, {
                    prov: "江苏",
                    label: "盐城"
                }, {
                    prov: "江苏",
                    label: "扬州"
                }, {
                    prov: "江苏",
                    label: "镇江"
                }, {
                    prov: "江苏",
                    label: "泰州"
                }, {
                    prov: "江苏",
                    label: "宿迁"
                }, {
                    prov: "浙江",
                    label: "浙江"
                },  {
                    prov: "浙江",
                    label: "杭州"
                }, {
                    prov: "浙江",
                    label: "宁波"
                }, {
                    prov: "浙江",
                    label: "温州"
                }, {
                    prov: "浙江",
                    label: "嘉兴"
                }, {
                    prov: "浙江",
                    label: "湖州"
                }, {
                    prov: "浙江",
                    label: "绍兴"
                }, {
                    prov: "浙江",
                    label: "金华"
                }, {
                    prov: "浙江",
                    label: "衢州"
                }, {
                    prov: "浙江",
                    label: "舟山"
                }, {
                    prov: "浙江",
                    label: "台州"
                }, {
                    prov: "浙江",
                    label: "丽水"
                }, {
                    prov: "安徽",
                    label: "合肥"
                }, {
                    prov: "安徽",
                    label: "安徽"
                }, {
                    prov: "安徽",
                    label: "芜湖"
                }, {
                    prov: "安徽",
                    label: "蚌埠"
                }, {
                    prov: "安徽",
                    label: "淮南"
                }, {
                    prov: "安徽",
                    label: "马鞍山"
                }, {
                    prov: "安徽",
                    label: "淮北"
                }, {
                    prov: "安徽",
                    label: "铜陵"
                }, {
                    prov: "安徽",
                    label: "安庆"
                }, {
                    prov: "安徽",
                    label: "黄山"
                }, {
                    prov: "安徽",
                    label: "滁州"
                }, {
                    prov: "安徽",
                    label: "阜阳"
                }, {
                    prov: "安徽",
                    label: "宿州"
                }, {
                    prov: "安徽",
                    label: "六安"
                }, {
                    prov: "安徽",
                    label: "亳州"
                }, {
                    prov: "安徽",
                    label: "池州"
                }, {
                    prov: "安徽",
                    label: "宣城"
                }, {
                    prov: "福建",
                    label: "福州"
                }, {
                    prov: "福建",
                    label: "福建"
                }, {
                    prov: "福建",
                    label: "厦门"
                }, {
                    prov: "福建",
                    label: "莆田"
                }, {
                    prov: "福建",
                    label: "三明"
                }, {
                    prov: "福建",
                    label: "泉州"
                }, {
                    prov: "福建",
                    label: "漳州"
                }, {
                    prov: "福建",
                    label: "南平"
                }, {
                    prov: "福建",
                    label: "龙岩"
                }, {
                    prov: "福建",
                    label: "宁德"
                }, {
                    prov: "江西",
                    label: "江西"
                }, {
                    prov: "江西",
                    label: "南昌"
                }, {
                    prov: "江西",
                    label: "景德镇"
                }, {
                    prov: "江西",
                    label: "萍乡"
                }, {
                    prov: "江西",
                    label: "九江"
                }, {
                    prov: "江西",
                    label: "新余"
                }, {
                    prov: "江西",
                    label: "鹰潭"
                }, {
                    prov: "江西",
                    label: "赣州"
                }, {
                    prov: "江西",
                    label: "吉安"
                }, {
                    prov: "江西",
                    label: "宜春"
                }, {
                    prov: "江西",
                    label: "抚州"
                }, {
                    prov: "江西",
                    label: "上饶"
                }, {
                    prov: "山东",
                    label: "济南"
                }, {
                    prov: "山东",
                    label: "山东"
                }, {
                    prov: "山东",
                    label: "青岛"
                }, {
                    prov: "山东",
                    label: "淄博"
                }, {
                    prov: "山东",
                    label: "枣庄"
                }, {
                    prov: "山东",
                    label: "东营"
                }, {
                    prov: "山东",
                    label: "烟台"
                }, {
                    prov: "山东",
                    label: "潍坊"
                }, {
                    prov: "山东",
                    label: "济宁"
                }, {
                    prov: "山东",
                    label: "泰安"
                }, {
                    prov: "山东",
                    label: "威海"
                }, {
                    prov: "山东",
                    label: "日照"
                }, {
                    prov: "山东",
                    label: "莱芜"
                }, {
                    prov: "山东",
                    label: "临沂"
                }, {
                    prov: "山东",
                    label: "德州"
                }, {
                    prov: "山东",
                    label: "聊城"
                }, {
                    prov: "山东",
                    label: "滨州"
                }, {
                    prov: "山东",
                    label: "菏泽"
                }, {
                    prov: "河南",
                    label: "郑州"
                },  {
                    prov: "河南",
                    label: "河南"
                }, {
                    prov: "河南",
                    label: "开封"
                }, {
                    prov: "河南",
                    label: "洛阳"
                }, {
                    prov: "河南",
                    label: "平顶山"
                }, {
                    prov: "河南",
                    label: "安阳"
                }, {
                    prov: "河南",
                    label: "鹤壁"
                }, {
                    prov: "河南",
                    label: "新乡"
                }, {
                    prov: "河南",
                    label: "焦作"
                }, {
                    prov: "河南",
                    label: "濮阳"
                }, {
                    prov: "河南",
                    label: "许昌"
                }, {
                    prov: "河南",
                    label: "漯河"
                }, {
                    prov: "河南",
                    label: "三门峡"
                }, {
                    prov: "河南",
                    label: "南阳"
                }, {
                    prov: "河南",
                    label: "商丘"
                }, {
                    prov: "河南",
                    label: "信阳"
                }, {
                    prov: "河南",
                    label: "周口"
                }, {
                    prov: "河南",
                    label: "驻马店"
                },
//  {
//                     prov: "河南",
//                     label: "直辖级行政区划"
//                 }, 
                {
                    prov: "湖北",
                    label: "武汉"
                },{
                    prov: "湖北",
                    label: "湖北"
                }, {
                    prov: "湖北",
                    label: "黄石"
                }, {
                    prov: "湖北",
                    label: "十堰"
                }, {
                    prov: "湖北",
                    label: "宜昌"
                }, {
                    prov: "湖北",
                    label: "襄阳"
                }, {
                    prov: "湖北",
                    label: "鄂州"
                }, {
                    prov: "湖北",
                    label: "荆门"
                }, {
                    prov: "湖北",
                    label: "孝感"
                }, {
                    prov: "湖北",
                    label: "荆州"
                }, {
                    prov: "湖北",
                    label: "黄冈"
                }, {
                    prov: "湖北",
                    label: "咸宁"
                }, {
                    prov: "湖北",
                    label: "随州"
                },
//  {
//                     prov: "湖北",
//                     label: "恩施土家族苗族自治州"
//                 }, {
//                     prov: "湖北",
//                     label: "直辖级行政区划"
//                 }, 
{
                    prov: "湖北",
                    label: "仙桃"
                }, {
                    prov: "湖北",
                    label: "潜江"
                }, {
                    prov: "湖北",
                    label: "天门"
                }, {
                    prov: "湖北",
                    label: "神农架"
                }, {
                    prov: "湖南",
                    label: "湖南"
                }, {
                    prov: "湖南",
                    label: "长沙"
                }, {
                    prov: "湖南",
                    label: "株洲"
                }, {
                    prov: "湖南",
                    label: "湘潭"
                }, {
                    prov: "湖南",
                    label: "衡阳"
                }, {
                    prov: "湖南",
                    label: "邵阳"
                }, {
                    prov: "湖南",
                    label: "岳阳"
                }, {
                    prov: "湖南",
                    label: "常德"
                }, {
                    prov: "湖南",
                    label: "张家界"
                }, {
                    prov: "湖南",
                    label: "益阳"
                }, {
                    prov: "湖南",
                    label: "郴州"
                }, {
                    prov: "湖南",
                    label: "永州"
                }, {
                    prov: "湖南",
                    label: "怀化"
                }, {
                    prov: "湖南",
                    label: "娄底"
                }, 
// {
//                     prov: "湖南",
//                     label: "湘西土家族苗族自治州"
//                 },
                {
                    prov: "广东",
                    label: "广州"
                }, {
                    prov: "广东",
                    label: "广东"
                }, {
                    prov: "广东",
                    label: "韶关"
                }, {
                    prov: "广东",
                    label: "深圳"
                }, {
                    prov: "广东",
                    label: "珠海"
                }, {
                    prov: "广东",
                    label: "汕头"
                }, {
                    prov: "广东",
                    label: "佛山"
                }, {
                    prov: "广东",
                    label: "江门"
                }, {
                    prov: "广东",
                    label: "湛江"
                }, {
                    prov: "广东",
                    label: "茂名"
                }, {
                    prov: "广东",
                    label: "肇庆"
                }, {
                    prov: "广东",
                    label: "惠州"
                }, {
                    prov: "广东",
                    label: "梅州"
                }, {
                    prov: "广东",
                    label: "汕尾"
                }, {
                    prov: "广东",
                    label: "河源"
                }, {
                    prov: "广东",
                    label: "阳江"
                }, {
                    prov: "广东",
                    label: "清远"
                }, {
                    prov: "广东",
                    label: "东莞"
                }, {
                    prov: "广东",
                    label: "中山"
                }, {
                    prov: "广东",
                    label: "潮州"
                }, {
                    prov: "广东",
                    label: "揭阳"
                }, {
                    prov: "广东",
                    label: "云浮"
                }, 
// {
//                     prov: "广西壮族",
//                     label: "南宁"
//                 }, {
//                     prov: "广西壮族",
//                     label: "柳州"
//                 }, {
//                     prov: "广西壮族",
//                     label: "桂林"
//                 }, {
//                     prov: "广西壮族",
//                     label: "梧州"
//                 }, {
//                     prov: "广西壮族",
//                     label: "北海"
//                 }, {
//                     prov: "广西壮族",
//                     label: "防城港"
//                 }, {
//                     prov: "广西壮族",
//                     label: "钦州"
//                 }, {
//                     prov: "广西壮族",
//                     label: "贵港"
//                 }, {
//                     prov: "广西壮族",
//                     label: "玉林"
//                 }, {
//                     prov: "广西壮族",
//                     label: "百色"
//                 }, {
//                     prov: "广西壮族",
//                     label: "贺州"
//                 }, {
//                     prov: "广西壮族",
//                     label: "河池"
//                 }, {
//                     prov: "广西壮族",
//                     label: "来宾"
//                 }, {
//                     prov: "广西壮族",
//                     label: "崇左"
//                 }, 
// {
//                     prov: "海南",
//                     label: "海口"
//                 }, {
//                     prov: "海南",
//                     label: "三亚"
//                 }, {
//                     prov: "海南",
//                     label: "三沙"
//                 }, 
// {
//                     prov: "海南",
//                     label: "直辖级行政区划"
//                 }, 
                {
                    prov: "海南",
                    label: "五指山"
                }, {
                    prov: "海南",
                    label: "海南"
                }, {
                    prov: "海南",
                    label: "琼海"
                }, {
                    prov: "海南",
                    label: "儋州"
                }, {
                    prov: "海南",
                    label: "文昌"
                }, {
                    prov: "海南",
                    label: "万宁"
                }, {
                    prov: "海南",
                    label: "东方"
                }, {
                    prov: "海南",
                    label: "定安"
                }, {
                    prov: "海南",
                    label: "屯昌"
                }, {
                    prov: "海南",
                    label: "澄迈"
                }, {
                    prov: "海南",
                    label: "临高"
                },
//  {
//                     prov: "海南",
//                     label: "白沙黎族自治"
//                 }, {
//                     prov: "海南",
//                     label: "昌江黎族自治"
//                 }, {
//                     prov: "海南",
//                     label: "乐东黎族自治"
//                 }, {
//                     prov: "海南",
//                     label: "陵水黎族自治"
//                 }, {
//                     prov: "海南",
//                     label: "保亭黎族苗族自治"
//                 }, {
//                     prov: "海南",
//                     label: "琼中黎族苗族自治"
//                 }, 
{
                    prov: "重庆",
                    label: "重庆"
                }, {
                    prov: "四川",
                    label: "成都"
                },{
                    prov: "四川",
                    label: "四川"
                }, {
                    prov: "四川",
                    label: "自贡"
                }, {
                    prov: "四川",
                    label: "攀枝花"
                }, {
                    prov: "四川",
                    label: "泸州"
                }, {
                    prov: "四川",
                    label: "德阳"
                }, {
                    prov: "四川",
                    label: "绵阳"
                }, {
                    prov: "四川",
                    label: "广元"
                }, {
                    prov: "四川",
                    label: "遂宁"
                }, {
                    prov: "四川",
                    label: "内江"
                }, {
                    prov: "四川",
                    label: "乐山"
                }, {
                    prov: "四川",
                    label: "南充"
                }, {
                    prov: "四川",
                    label: "眉山"
                }, {
                    prov: "四川",
                    label: "宜宾"
                }, {
                    prov: "四川",
                    label: "广安"
                }, {
                    prov: "四川",
                    label: "达州"
                }, {
                    prov: "四川",
                    label: "雅安"
                }, {
                    prov: "四川",
                    label: "巴中"
                }, {
                    prov: "四川",
                    label: "资阳"
                }, 
// {
//                     prov: "四川",
//                     label: "阿坝藏族羌族自治州"
//                 }, {
//                     prov: "四川",
//                     label: "甘孜藏族自治州"
//                 }, {
//                     prov: "四川",
//                     label: "凉山彝族自治州"
//                 }, 
                {
                    prov: "贵州",
                    label: "贵州"
                }, {
                    prov: "贵州",
                    label: "贵阳"
                }, {
                    prov: "贵州",
                    label: "六盘水"
                }, {
                    prov: "贵州",
                    label: "遵义"
                }, {
                    prov: "贵州",
                    label: "安顺"
                }, {
                    prov: "贵州",
                    label: "毕节"
                }, {
                    prov: "贵州",
                    label: "铜仁"
                },
//  {
//                     prov: "贵州",
//                     label: "黔西南布依族苗族自治州"
//                 }, {
//                     prov: "贵州",
//                     label: "黔东南苗族侗族自治州"
//                 }, {
//                     prov: "贵州",
//                     label: "黔南布依族苗族自治州"
//                 }, 
                {
                    prov: "云南",
                    label: "昆明"
                }, {
                    prov: "云南",
                    label: "云南"
                }, {
                    prov: "云南",
                    label: "曲靖"
                }, {
                    prov: "云南",
                    label: "玉溪"
                }, {
                    prov: "云南",
                    label: "保山"
                }, {
                    prov: "云南",
                    label: "昭通"
                }, {
                    prov: "云南",
                    label: "丽江"
                }, {
                    prov: "云南",
                    label: "普洱"
                }, {
                    prov: "云南",
                    label: "临沧"
                },
//  {
//                     prov: "云南",
//                     label: "楚雄彝族自治州"
//                 }, {
//                     prov: "云南",
//                     label: "红河哈尼族彝族自治州"
//                 }, {
//                     prov: "云南",
//                     label: "文山壮族苗族自治州"
//                 }, {
//                     prov: "云南",
//                     label: "西双版纳傣族自治州"
//                 }, {
//                     prov: "云南",
//                     label: "大理白族自治州"
//                 }, {
//                     prov: "云南",
//                     label: "德宏傣族景颇族自治州"
//                 }, {
//                     prov: "云南",
//                     label: "怒江傈僳族自治州"
//                 }, {
//                     prov: "云南",
//                     label: "迪庆藏族自治州"
//                 },
                {
                    prov: "西藏",
                    label: "西藏"
                },{
                    prov: "西藏",
                    label: "拉萨"
                }, {
                    prov: "西藏",
                    label: "昌都地区"
                }, {
                    prov: "西藏",
                    label: "山南地区"
                }, {
                    prov: "西藏",
                    label: "日喀则地区"
                }, {
                    prov: "西藏",
                    label: "那曲地区"
                }, {
                    prov: "西藏",
                    label: "阿里地区"
                }, {
                    prov: "西藏",
                    label: "林芝地区"
                }, {
                    prov: "陕西",
                    label: "陕西"
                }, {
                    prov: "陕西",
                    label: "西安"
                }, {
                    prov: "陕西",
                    label: "铜川"
                }, {
                    prov: "陕西",
                    label: "宝鸡"
                }, {
                    prov: "陕西",
                    label: "咸阳"
                }, {
                    prov: "陕西",
                    label: "渭南"
                }, {
                    prov: "陕西",
                    label: "延安"
                }, {
                    prov: "陕西",
                    label: "汉中"
                }, {
                    prov: "陕西",
                    label: "榆林"
                }, {
                    prov: "陕西",
                    label: "安康"
                }, {
                    prov: "陕西",
                    label: "商洛"
                }, {
                    prov: "甘肃",
                    label: "兰州"
                }, {
                    prov: "甘肃",
                    label: "甘肃"
                }, {
                    prov: "甘肃",
                    label: "嘉峪关"
                }, {
                    prov: "甘肃",
                    label: "金昌"
                }, {
                    prov: "甘肃",
                    label: "白银"
                }, {
                    prov: "甘肃",
                    label: "天水"
                }, {
                    prov: "甘肃",
                    label: "武威"
                }, {
                    prov: "甘肃",
                    label: "张掖"
                }, {
                    prov: "甘肃",
                    label: "平凉"
                }, {
                    prov: "甘肃",
                    label: "酒泉"
                }, {
                    prov: "甘肃",
                    label: "庆阳"
                }, {
                    prov: "甘肃",
                    label: "定西"
                }, {
                    prov: "甘肃",
                    label: "陇南"
                }, 
// {
//                     prov: "甘肃",
//                     label: "临夏回族自治州"
//                 }, {
//                     prov: "甘肃",
//                     label: "甘南藏族自治州"
//                 }, {
//                     prov: "青海",
//                     label: "西宁"
//                 }, {
//                     prov: "青海",
//                     label: "海东"
//                 }, {
//                     prov: "青海",
//                     label: "海北藏族自治州"
//                 }, {
//                     prov: "青海",
//                     label: "黄南藏族自治州"
//                 }, {
//                     prov: "青海",
//                     label: "海南藏族自治州"
//                 }, {
//                     prov: "青海",
//                     label: "果洛藏族自治州"
//                 }, {
//                     prov: "青海",
//                     label: "玉树藏族自治州"
//                 }, {
//                     prov: "青海",
//                     label: "海西蒙古族藏族自治州"
//                 }, 
// {
//                     prov: "宁夏回族",
//                     label: "银川"
//                 }, {
//                     prov: "宁夏回族",
//                     label: "石嘴山"
//                 }, {
//                     prov: "宁夏回族",
//                     label: "吴忠"
//                 }, {
//                     prov: "宁夏回族",
//                     label: "固原"
//                 }, {
//                     prov: "宁夏回族",
//                     label: "中卫"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "乌鲁木齐"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "克拉玛依"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "吐鲁番地区"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "哈密地区"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "昌吉回族自治州"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "博尔塔拉蒙古自治州"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "巴音郭楞蒙古自治州"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "阿克苏地区"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "克孜勒苏柯尔克孜自治州"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "喀什地区"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "和田地区"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "伊犁哈萨克自治州"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "塔城地区"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "阿勒泰地区"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "直辖级行政区划"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "石河子"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "阿拉尔"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "图木舒克"
//                 }, {
//                     prov: "新疆维吾尔",
//                     label: "五家渠"
//                 }, {
//                     prov: "台湾",
//                     label: "台北"
//                 }, {
//                     prov: "台湾",
//                     label: "高雄"
//                 }, {
//                     prov: "台湾",
//                     label: "基隆"
//                 }, {
//                     prov: "台湾",
//                     label: "台中"
//                 }, {
//                     prov: "台湾",
//                     label: "台南"
//                 }, {
//                     prov: "台湾",
//                     label: "新竹"
//                 }, {
//                     prov: "台湾",
//                     label: "嘉义"
//                 }, {
//                     prov: "台湾",
//                     label: "直辖"
//                 }, {
//                     prov: "香港特别行政区",
//                     label: "香港岛"
//                 }, {
//                     prov: "香港特别行政区",
//                     label: "九龙"
//                 }, {
//                     prov: "香港特别行政区",
//                     label: "新界"
//                 }, {
//                     prov: "澳门特别行政区",
//                     label: "澳门半岛"
//                 }, {
//                     prov: "澳门特别行政区",
//                     label: "澳门离岛"
//                 }, {
//                     prov: "澳门特别行政区",
//                     label: "无堂区划分区域"
//                 }

];
                for (var val of allCity){
                    if (prov == val.prov){
                        tempCity.push({label: val.label, value: val.label})
                    }
                }
                this.citys = tempCity;
            },
            getCity: function (city) {
                //console.log(city);
                //console.log(this.selectCity)
            },
            handleSubmit(){
                this.$emit("onChange", this.selectProv==this.selectCity?this.selectProv:this.selectProv+this.selectCity);
           }
        }
    }

</script>


// WEBPACK FOOTER //
// src/components/_widget/ProvinceCity.vue